"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiAccounts16 = {
    paths: [
        {
            path: 'M2,14 L7,14 L7,6 L2,6 L2,14 Z M8,4 C8.55228475,4 9,4.44771525 9,5 L9,15 C9,15.5522847 8.55228475,16 8,16 L1,16 C0.44771525,16 0,15.5522847 0,15 L0,5 C0,4.44771525 0.44771525,4 1,4 L8,4 Z M12,0 C12.2761424,0 12.5261424,0.111928813 12.7071068,0.292893219 C12.8880712,0.473857625 13,0.723857625 13,1 L13,1 L13,9 C13,9.55228475 12.5522847,10 12,10 C11.4477153,10 11,9.55228475 11,9 L11,9 L11,2 L4,2 C3.44771525,2 3,1.55228475 3,1 C3,0.44771525 3.44771525,0 4,0 L4,0 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Accounts',
    width: 13,
    height: 16,
};
var muiAccounts24 = {
    paths: [
        {
            path: 'M13,4 C13.5522847,4 14,4.44771525 14,5 L14,23 C14,23.5522847 13.5522847,24 13,24 L1,24 C0.44771525,24 6.76353751e-17,23.5522847 0,23 L0,5 C-6.76353751e-17,4.44771525 0.44771525,4 1,4 L13,4 Z M12,6 L2,6 L2,22 L12,22 L12,6 Z M17,0 C17.5522847,0 18,0.44771525 18,1 L18,1 L18,13 C18,13.5522847 17.5522847,14 17,14 C16.4477153,14 16,13.5522847 16,13 L16,13 L16,2 L5,2 C4.44771525,2 4,1.55228475 4,1 C4,0.44771525 4.44771525,0 5,0 L5,0 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Accounts',
    width: 18,
    height: 24,
};
var muiAccounts = {
    base: muiAccounts16,
    smIcon: muiAccounts16,
    lgIcon: muiAccounts24,
};
exports.muiAccounts = muiAccounts;
//# sourceMappingURL=accounts.js.map